import axios from 'axios';
import { JsonResponse } from 'core/models/response';
import { Board, BoardListResponse, CreateBoardPayload } from '../models/board';

export const onGetBoardsList = async (page: number = 1) => {
	try {
		const response = await axios.get<JsonResponse<BoardListResponse>>('dashboard/boards', {
			params: { page },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetBoardById = async (id: string) => {
	try {
		const response = await axios.get<JsonResponse<Board>>(`dashboard/boards/${id}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetActiveBoard = async () => {
	try {
		const response = await axios.get<JsonResponse<Board>>(`dashboard/boards/active-board`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCreateBoard = async (payload: CreateBoardPayload) => {
	try {
		const response = await axios.post<JsonResponse<Board>>(`dashboard/boards`, payload);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onAppointBoard = async (id: string, verified_using: 'password' | 'otp', code: string) => {
	try {
		const response = await axios.post<JsonResponse<Board>>(`dashboard/boards/${id}/appoint`, {
			verified_using,
			[verified_using]: code,
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onSendBoardOTP = async (id: string) => {
	try {
		const response = await axios.post<JsonResponse<Board>>(`dashboard/boards/${id}/send-otp`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onDeleteBoard = async (id: number) => {
	try {
		const response = await axios.delete<JsonResponse<Board>>(`dashboard/boards/${id}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
